export type { ZoomModalProps } from "./ZoomModal";
export { ZoomModal } from "./ZoomModal";
